/* istanbul ignore file */

import { createUseStyles } from '@glu/theming';

const styles = ({
  button: {
    tertiary: { hoverColor, textColor }
  },
  spacing: { unit }
}) => ({
  left: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: 0,
    margin: '0 auto 0 10px',
    minWidth: 170
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    minHeight: unit * 2.5,
    margin: '0 5px 0 auto',
    '& > *:last-child button': {
      margin: 0
    }
  },
  syncText: {
    fontSize: unit * 1.5,
    margin: '0 10px 0 0'
  },
  gridHeader: {
    display: 'flex',
    padding: `0 0 ${unit * 0.5}px`,
    '& .glu-react-icon > div': {
      display: 'flex'
    },
    '& svg': {
      fill: textColor,
      margin: '0 5px 0 0',
      cursor: 'pointer',
      '&:hover': {
        fill: hoverColor
      }
    },
    '& input': {
      display: 'flex'
    }
  }
});

export default createUseStyles(styles);
